import { render } from "./RedPrize.vue?vue&type=template&id=17e9fe0c&scoped=true"
import script from "./RedPrize.vue?vue&type=script&lang=ts"
export * from "./RedPrize.vue?vue&type=script&lang=ts"

import "./RedPrize.vue?vue&type=style&index=0&id=17e9fe0c&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-17e9fe0c"

export default script